import React, { useState } from "react";
import WhiteButton from "../WhiteButton/WhiteButton";
import "./QuizzyPlusBanner.scss";
import Sparkles from "react-sparkle";
import ReactGA from "react-ga4";
import CTAButton from "../CTAButton/CTAButton";

function QuizzyPlusBanner(props) {
  return (
    <div className="quizzy-plus-banner" style={props.style ? props.style : {}}>
      <Sparkles flicker={false} count={20} fadeOutSpeed={20} />
      <div className="left banner-left">
        <h3>Quizzy+</h3>
        <h2>Turn that A into an A+</h2>
        <p>{props.subtitle ?? "Learn your terms faster with Quizzy+"}</p>
        <CTAButton
          text="Get Started"
          color="pink"
          onClick={() => {
            ReactGA.event({
              category: "User",
              action: "Clicked Upgrade",
              label: "Clicked from Quizzy+ Banner",
            });
            window.location.href = "https://quizzynow.com/upgrade";
          }}
        ></CTAButton>
      </div>
      <div className="right">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            height: "100%",
            paddingInline: "2rem",
            alignItems: "center",
          }}
        >
          <div className="features">
            <h2>With Quizzy+</h2>
            <div className="features-rows">
              <div className="features-flex">
                <div className="feature">
                  <svg
                    id="done_black_24dp_1_"
                    data-name="done_black_24dp (1)"
                    xmlns="http://www.w3.org/2000/svg"
                    width="35.293"
                    height="35.293"
                    viewBox="0 0 35.293 35.293"
                  >
                    <path
                      id="Path_132"
                      data-name="Path 132"
                      d="M0,0H35.293V35.293H0Z"
                      fill="none"
                    />
                    <path
                      id="Path_133"
                      data-name="Path 133"
                      d="M11.635,21.188,5.459,15.011,3.4,17.07l8.235,8.235L29.281,7.659,27.223,5.6Z"
                      transform="translate(1.6 2.635)"
                      fill="#8358e8"
                    />
                  </svg>
                  <p>{"AI-Enhanced Study Plan"}</p>
                </div>
                <div className="feature">
                  <svg
                    id="done_black_24dp_1_"
                    data-name="done_black_24dp (1)"
                    xmlns="http://www.w3.org/2000/svg"
                    width="35.293"
                    height="35.293"
                    viewBox="0 0 35.293 35.293"
                  >
                    <path
                      id="Path_132"
                      data-name="Path 132"
                      d="M0,0H35.293V35.293H0Z"
                      fill="none"
                    />
                    <path
                      id="Path_133"
                      data-name="Path 133"
                      d="M11.635,21.188,5.459,15.011,3.4,17.07l8.235,8.235L29.281,7.659,27.223,5.6Z"
                      transform="translate(1.6 2.635)"
                      fill="#8358e8"
                    />
                  </svg>
                  <p>{"Full Schedule Control"}</p>
                </div>
                <div className="feature">
                  <svg
                    id="done_black_24dp_1_"
                    data-name="done_black_24dp (1)"
                    xmlns="http://www.w3.org/2000/svg"
                    width="35.293"
                    height="35.293"
                    viewBox="0 0 35.293 35.293"
                  >
                    <path
                      id="Path_132"
                      data-name="Path 132"
                      d="M0,0H35.293V35.293H0Z"
                      fill="none"
                    />
                    <path
                      id="Path_133"
                      data-name="Path 133"
                      d="M11.635,21.188,5.459,15.011,3.4,17.07l8.235,8.235L29.281,7.659,27.223,5.6Z"
                      transform="translate(1.6 2.635)"
                      fill="#8358e8"
                    />
                  </svg>
                  <p>{"Most Difficult Terms"}</p>
                </div>
                <div className="feature">
                  <svg
                    id="done_black_24dp_1_"
                    data-name="done_black_24dp (1)"
                    xmlns="http://www.w3.org/2000/svg"
                    width="35.293"
                    height="35.293"
                    viewBox="0 0 35.293 35.293"
                  >
                    <path
                      id="Path_132"
                      data-name="Path 132"
                      d="M0,0H35.293V35.293H0Z"
                      fill="none"
                    />
                    <path
                      id="Path_133"
                      data-name="Path 133"
                      d="M11.635,21.188,5.459,15.011,3.4,17.07l8.235,8.235L29.281,7.659,27.223,5.6Z"
                      transform="translate(1.6 2.635)"
                      fill="#8358e8"
                    />
                  </svg>
                  <p>{"Upload Bigger Images"}</p>
                </div>
              </div>
              <div className="features-flex">
                <div className="feature">
                  <svg
                    id="done_black_24dp_1_"
                    data-name="done_black_24dp (1)"
                    xmlns="http://www.w3.org/2000/svg"
                    width="35.293"
                    height="35.293"
                    viewBox="0 0 35.293 35.293"
                  >
                    <path
                      id="Path_132"
                      data-name="Path 132"
                      d="M0,0H35.293V35.293H0Z"
                      fill="none"
                    />
                    <path
                      id="Path_133"
                      data-name="Path 133"
                      d="M11.635,21.188,5.459,15.011,3.4,17.07l8.235,8.235L29.281,7.659,27.223,5.6Z"
                      transform="translate(1.6 2.635)"
                      fill="#8358e8"
                    />
                  </svg>
                  <p>{"Upload Animated Avatars"}</p>
                </div>
                <div className="feature">
                  <svg
                    id="done_black_24dp_1_"
                    data-name="done_black_24dp (1)"
                    xmlns="http://www.w3.org/2000/svg"
                    width="35.293"
                    height="35.293"
                    viewBox="0 0 35.293 35.293"
                  >
                    <path
                      id="Path_132"
                      data-name="Path 132"
                      d="M0,0H35.293V35.293H0Z"
                      fill="none"
                    />
                    <path
                      id="Path_133"
                      data-name="Path 133"
                      d="M11.635,21.188,5.459,15.011,3.4,17.07l8.235,8.235L29.281,7.659,27.223,5.6Z"
                      transform="translate(1.6 2.635)"
                      fill="#8358e8"
                    />
                  </svg>
                  <p>{"Add Tasks, and more!"}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QuizzyPlusBanner;
